import { render } from "./LoginFlow.vue?vue&type=template&id=08bcb7c0"
import script from "./LoginFlow.vue?vue&type=script&lang=js"
export * from "./LoginFlow.vue?vue&type=script&lang=js"

import exportComponent from "/__w/system/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__